import * as React from 'react'
import MUICardHeader from '@mui/material/CardHeader'

const CardHeader = (props) => <MUICardHeader {...props} />

export default CardHeader
